import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Tag, Popover, Steps } from 'antd'
import { getItemProgress } from '../../../../services/api/3dApi'
import { convertDateOverTimeProgress } from '../../../helpers/convertDateOverTime'

const { Step } = Steps

// 5 mốc cố định của thanh tiến độ, xếp đúng thứ tự luồng sản xuất.
// Index ở đây cũng chính là giá trị `current` truyền cho Steps: với current = k, antd đặt
// mốc 0..k-1 là finish (đoạn nối xanh), mốc k trở đi là process/wait (đoạn nối xám).
// Mốc May (`sewed`) không có item_status tương ứng: may xong item vẫn giữ `sewing` cho tới
// `completed`. Item-progress trả cờ `sewed` theo lô (đã may hoặc đã nhận may) để tô mốc May.
const COLUMN_KEYS = ['pending', 'printed', 'transferred', 'sewed', 'completed']

// Trạng thái "đang làm" chưa tính là đã qua mốc đó, quy về mốc đã xong liền trước.
const IN_PROGRESS_OF = {
    printing: 'pending',
    transferring: 'printed',
    confirmed: 'transferred', // QC sau ép: đã qua In và Ép
    wait_to_sew: 'transferred',
    sewing: 'transferred',
}

// Index mốc đã qua xa nhất. Trả -1 với trạng thái ngoài luồng hoặc dữ liệu thiếu — khi đó
// để thanh toàn xám, không tô xanh sai.
const getCurrentIndex = ({ batch_status, item_status, sewed }) => {
    // batch đã completed thì item coi như đi hết luồng.
    if (batch_status === 'completed' || item_status === 'moved') return COLUMN_KEYS.length - 1

    // Lô đã may / đã nhận may: item vẫn `sewing` nhưng đã qua mốc May.
    // So sánh chặt để BE cũ chưa trả `sewed` vẫn hiển thị như trước.
    if (item_status === 'sewing' && sewed === true) return COLUMN_KEYS.indexOf('sewed')

    return COLUMN_KEYS.indexOf(IN_PROGRESS_OF[item_status] || item_status)
}

class PrintInfoCol extends React.PureComponent {
    state = {
        listItemProgress: [],
        error: '',
        visible: false,
        loading: false
    }

    _fetchItemProgress = async () => {
        this.setState({
            listItemProgress: [],
            error: '',
        })
        try {
            const { pos, barcode_number } = this.props
            const batchItem = `${barcode_number}_${pos}` || ''
            const { success, data, error } = await getItemProgress(batchItem)

            if (!success) {
                this.setState({
                    error: error
                })
            }

            this.setState({
                listItemProgress: data
            })

        } catch (error) {
            this.setState({
                error: error.message
            })
        }
    }

    handlePopoverVisibleChange = (visible) => {
        this.setState({
            visible
        })
    }

    handlePopoverDelay = () => {
        this.setState({
            loading: true
        })
        setTimeout(() => {
            this.setState({
                visible: true,
                loading: false,
            })
        }, 500)
    }

    render() {
        const { pos, total, order3d, order3d_at, printed_at, type, printed_ip, barcode_number, tags } = this.props
        const { listItemProgress, visible, loading } = this.state

        const printedAt = printed_at ? new Date(printed_at).toLocaleString('en-GB') : ''
        const printedIp = printed_ip || ''
        const isSpecialTag = Array.isArray(tags) && tags.includes('priority-store')

        const tool3d_support_type = ['CANVAS', 'POSTER', 'TSHIRT_3D', 'SWEATSHIRT_3D', 'HOODIE_3D', 'ZIP HOODIE 3D', 'ZIP_HD_18', 'TSHIRT_02', 'SW_18', 'HD_18']
        const require_tool3d = (tool3d_support_type.indexOf(type) !== -1)
        const className3D = classNames({
            'font-size-ms': true,
            'text-success': order3d === true,
            'text-muted': typeof order3d === 'undefined',
            'text-danger': order3d === false
        })
        const order3d_time = order3d_at ? (new Date(order3d_at).toLocaleString('en-GB', {
            day: 'numeric',
            month: 'numeric',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        })) : ''
        const classNamePrinted = classNames({
            'text-success': printedAt,
            'font-size-sm': true
        })

        const customDot = (dot) => dot
        const statusProgress = status => {
            switch (status) {
                case "printed":
                    return "Đã in"
                case "printing":
                    return "Đang in"
                case "transferred":
                    return "Đã ép"
                case "transferring":
                    return "Đang ép"
                case "sewing":
                    return "Đang may"
                case "wait_to_sew":
                    return "Chờ may"
                case "completed":
                    return "Hoàn thành"
                case "moved":
                    return "Moved"
                case "confirmed":
                    return "QC sau ép"
                default:
                    return status
            }
        }

        const content = (
            Array.isArray(listItemProgress) && listItemProgress.length ?
                listItemProgress.map((itemProgress, index) => {
                    const { batch_name, batch_status, item_status, printed_overtime, transferred_overtime, sewed_overtime, sewed } = Object.assign({}, itemProgress)
                    const currentIndex = getCurrentIndex({ batch_status, item_status, sewed })
                    const data = [
                        { id: "1", name: "Chưa in" },
                        { id: "2", name: "In" },
                        { id: "3", name: "Ép" },
                        { id: "4", name: "May" },
                        { id: "5", name: "QCHT" },
                    ]
                    if (printed_overtime > 0) {
                        data[0] = { ...data[0], isOvertime: true }
                        data[1] = { ...data[1], overtime: printed_overtime }
                    }
                    if (transferred_overtime > 0) {
                        data[1] = { ...data[1], isOvertime: true }
                        data[2] = { ...data[2], overtime: transferred_overtime }
                    }
                    if (sewed_overtime > 0) {
                        data[2] = { ...data[2], isOvertime: true }
                        data[3] = { ...data[3], overtime: sewed_overtime }
                    }

                    return (
                        <div className={`progressItem ${index % 2 === 0 ? 'even' : 'odd'}`} key={index}>
                            <div className="d-flex justify-content-center align-items-center">
                                <div className="d-flex flex-column w-25 font-weight-bold">
                                    <div className="batchStatus" style={{ whiteSpace: 'nowrap' }}>
                                        {`${batch_name}: ${statusProgress(batch_status)}`}
                                    </div>
                                    <div className="itemStatus">
                                        <Tag color="#108ee9" className='font-weight-bold'>{item_status ? statusProgress(item_status) : ''}</Tag>
                                    </div>
                                </div>
                                <Steps
                                    current={currentIndex < 0 ? 0 : currentIndex}
                                    progressDot={customDot}
                                >
                                    {data.map((item, index) => (
                                        <Step className={item.isOvertime ? 'isOvertime' : ''} key={index} title={item.name} description={item.overtime ? convertDateOverTimeProgress(item.overtime) : ''} />
                                    ))}
                                </Steps>
                            </div>
                        </div>
                    )
                }) : (
                    this.state.error ? <span className='text-danger p-2'>{typeof this.state.error === 'string' ? this.state.error : 'Không lấy được tiến độ item'}</span> : <span className='font-weight-bold p-2'>Đây là đơn 2D</span>
                )
        )

        return (
            <div className="Printed">
                {
                    <span className="font-weight-bold d-block"><a target='_blank' href={`/next-item-detail?item=${barcode_number}_${pos}`} rel="noopener noreferrer">{pos}/{total}</a></span>
                }
                {
                    require_tool3d &&
                    <div className={className3D}>
                        <span className="icon-image2 icon-sxx mr-1" />{order3d_time}
                    </div>
                }
                {
                    printedAt &&
                    <div className={classNamePrinted}>
                        <span className="badge badge-mark border-success mr-1" />{printedAt}
                    </div>
                }
                {
                    printedIp &&
                    <div className="text-muted font-size-sm">
                        <span className="badge badge-mark border-danger mr-1" />
                        {printedIp}
                    </div>
                }
                {
                    isSpecialTag && <Tag color="#ff0000" className='font-weight-bold'>Đặc biệt</Tag>
                }
                <Popover content={loading ? <span className='p-2'>Loading...</span> : content} trigger="click" visible={visible} overlayClassName="popoverProgress" placement='topLeft' onVisibleChange={this.handlePopoverVisibleChange} onClick={this.handlePopoverDelay}>
                    <Tag color="#108ee9" className='font-weight-bold cursor-pointer my-1' onClick={() => this._fetchItemProgress()}>Item status</Tag>
                </Popover>
            </div>
        )
    }
}

PrintInfoCol.propTypes = {
    pos: PropTypes.number,
    total: PropTypes.number.isRequired,
    order3d: PropTypes.bool.isRequired,
    barcode_number: PropTypes.number,
    order3d_at: PropTypes.string
}

export default PrintInfoCol
